import Icon from 'veui/components/Icon'

Icon.register({
  'file-excel': {
    paths: [
      {
        fill: '#26a358',
        d: 'M27.7 9.81l-6.68-8A1.34 1.34 0 0020 1.33H6a2 2 0 00-2 2v25.34c0 1.1.9 2 2 2h20a2 2 0 002-2v-18c0-.05-.07-.56-.3-.86z'
      },
      {
        fill: '#85c98c',
        d: 'M21.02 1.81A1.34 1.34 0 0020 1.33v7.34c0 1.1.9 2 2 2h6c0-.05-.07-.56-.3-.86z'
      },
      {
        fill: '#fff',
        d: 'M20.85 13.3h-1.58c-.2 0-.39.1-.5.26l-2.53 3.4a.32.32 0 01-.44.07.3.3 0 01-.06-.07l-2.53-3.4a.63.63 0 00-.51-.25h-1.55a.32.32 0 00-.25.5l3.7 5a.32.32 0 010 .37l-3.7 5a.32.32 0 00.25.5h1.58c.2 0 .4-.1.5-.26l2.52-3.38a.32.32 0 01.44-.07c.02.02.05.04.06.07l2.52 3.38c.11.16.3.26.5.26h1.58a.32.32 0 00.26-.5l-3.71-4.99c-.04-.05-.06-.12-.06-.19s.02-.13.06-.19l3.7-5a.32.32 0 00-.25-.5z'
      }
    ],
    width: '32',
    height: '32'
  }
})
